module.exports = "const UniformUiComponents = window.__uniformui_Components;\n"